import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGavel, faClipboardList, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const MessageRow = styled.tr`
  text-align: center;
`;

const MessageTd = styled.td`
  padding: 100px;
  font-size:18pt;
  font-style: italic;
`;
const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`; 

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: white;
  overflow: hidden;
`;

const Th = styled.th`
  background-color:#f2f2f2;
  color: black;
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  font-size:14px;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
`;

const TimerTd = styled(Td)`
  color: ${(props) => (props.isCritical ? 'red' : 'black')};
`;

const Button = styled.button`
  padding: 8px 16px;
  margin: 4px;
  font-size: 14px;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;
const CountsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const CountBox = styled.div`
  color: #black;
  border: 1px;
  border-style: double;
  padding: 30px;
  border-radius: 10px;
  flex: 1;
  text-align: center;
  margin: 0 10px;
  border-color:#dddddd;
  &:first-child {
    margin-left: 0;
  }
  
  &:last-child {
    margin-right: 0;
  }
`;

const CountNumber = styled.div`
  font-size: 58px;
  font-weight: bold;
`;

const IconLabel = styled.div`
font-size: 18pt;
    padding: 10px;
    font-weight: bold;
`;
const CountLabel = styled.div`
  font-size: 18px;
  margin-top: 10px;
`;
const statusDisplay = (status) => {
  switch (status) {
    case "public_reaction":
      return "재경매";
    case "public_action":
      return "경매";
    case "reassigned":
      return "재할당";
    case "canceled":
      return "취소";
    case "assigned":
      return "할당";
    case "requested":
      return "요청 중";
    case "awarded":
      return "낙찰됨";
    case "last_action":
        return "마감경매";
    case "last_awarded":
        return "마감 낙찰됨";
    case "completed":
      return "대행완료";
    default:
      return status;
  }
};
const PublicOrdersList = () => {
  const [orders, setOrders] = useState([]);
  // const [orders, setOrders] = useState([{agent_status:'할당',menu_id:'111',order_id:'222',agent_status:'111',movie_title:'베테랑',theater:'건대 CGV',date: '2024-10-04',screening_time:'11:22',seat_info:'앞 우측 열',remainingTime:'00:10'}]);
  const navigate = useNavigate();
  const [orderCount, setOrderCount] = useState(0);
const [auctionCount, setAuctionCount] = useState(0);
useEffect(() => {
  let intervalId;

  const fetchCounts = async () => {
    try {
      const response = await fetch('/Acution/order-counts', {
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setOrderCount(data.orderCount);
      setAuctionCount(data.auctionCount);
    } catch (err) {
      console.error('주문 및 경매 건수 가져오는 중 오류 발생:', err);
    }
  };

  fetchCounts();
  intervalId = setInterval(fetchCounts, 60000); // 1분마다 갱신

  return () => clearInterval(intervalId); // 컴포넌트 언마운트 시 인터벌 제거
}, []);



  const fetchPublicOrders = async () => {
    try {
      const response = await fetch('/Acution/public-orders', {
        credentials: 'include',
      });
      const data = await response.json();
      setOrders(data);
    } catch (error) {
      console.error('Error fetching public orders:', error);
    }
  };
  useEffect(() => {
  

    fetchPublicOrders();

    const intervalId = setInterval(() => {
      setOrders((prevOrders) =>
        prevOrders.map((order) => {
          const remainingTime = calculateRemainingTime(order.end_time);
          return { ...order, remainingTime };
        })
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const calculateRemainingTime = (endTime) => {
    const end = new Date(endTime);
    const now = new Date();
    const diff = end - now;

    if (diff <= 0) {
      fetchPublicOrders();
      return 'Expired';
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

 

  const handleViewBidders = (menuId) => {
    navigate(`/Tiketting/PublicOrderBids/${menuId}`); // menu_id로 사용
  };

  return (
    <Container>
      {/* <Title>공개 경매 리스트</Title> */}
      <CountsContainer>
      <CountBox>
      <section>
        <FontAwesomeIcon icon={faClipboardList} size="2x" /><IconLabel>대행</IconLabel>
      </section>
        <CountNumber>{orderCount}</CountNumber>
        <CountLabel>현재 진행 중인 대행 건수</CountLabel>
      </CountBox>
      <CountBox>
      <section>
      <FontAwesomeIcon icon={faGavel} size="2x" /><IconLabel>경매</IconLabel>
        </section>
        <CountNumber>{auctionCount}</CountNumber>
        <CountLabel>현재 진행 중인 경매 건수</CountLabel>
      </CountBox>
    </CountsContainer>
      <Table>
        <thead>
          <tr>
            <Th>구분</Th>
            <Th>주문</Th>
            <Th colSpan={6}>영화제목 / 상영관 / 상영일자 / 상영시간 / 좌석 정보 / 인원수</Th>
            {/* <Th>상영관</Th>
            <Th>상영일자</Th>
            <Th>상영시간</Th>
            <Th>좌석 정보</Th>
            <Th>티켓 수량</Th> */}
            <Th>타임아웃</Th>
            <Th>입찰진행</Th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <MessageRow>
              <MessageTd colSpan="10"> 진행중인 공개 경매가 없습니다. </MessageTd>
            </MessageRow>
          ) : orders.map((order) => (
            <tr key={order.menu_id}> {/* menu_id로 변경 */}
             <Td>{statusDisplay(order.agent_status)}</Td>
             <Td>{order.order_id}</Td>
            <Td colSpan={6}>
            {order.movie_title+'/'+order.theater+'/'+order.date+'/'+order.screening_time+'/'+order.seat_info+' / '+(order.viewer_count || '정보없음')+'명'}
            </Td>
              {/* <Td>{order.agent_status}</Td>
              <Td>{order.movie_title}</Td>
              <Td>{order.theater}</Td>
              <Td>{order.date}</Td>
              <Td>{order.screening_time}</Td>
              <Td>{order.seat_info}</Td>
              <Td>{order.viewer_count}</Td> */}
              <TimerTd isCritical={order.remainingTime && order.remainingTime.split(':')[0] === '0' && parseInt(order.remainingTime.split(':')[1]) <= 59}>
                {order.remainingTime || calculateRemainingTime(order.end_time)}
              </TimerTd>
              <Td>
                <Button onClick={() => handleViewBidders(order.menu_id)}>입찰 진행</Button> {/* menu_id로 변경 */}
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>
     
    </Container>
  );
};

export default PublicOrdersList;
